
import { Divider, message, Popconfirm } from 'antd';
import React from 'react'
import { postFrom } from '../../axios';
import { API_merchant_findAll } from '../../axios/config';
import TableHelper from '../../components/TableHelper'
import { fetchTransferRecordLogList, fetchTransferRecordLogSftpUpload } from '../../services/transferRecordLog'
import {findDict, formatTime, moneyAddComma} from '../../utils'
import PageWrap from '../../components/PageWrap';
import TransferRecordFlowApprovalModal from './components/FlowApprovalModal';
import AuthButton from '../../components/AuthButton/AuthButton';
import TransferRecordDetail from './detail';
import TransferRecordDetailInfo from './detailInfo';
import TransferRecordUpdate from "./update";
import TransferRecordSettlementUpdate from "./settlementUpdate";
import TransferRecordFlowListModal from './components/FlowListModal';
import AccountingRecordDetail from "../AccountingRecord/detail";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-24 16:26:06
 * @LastEditTime: 2021-12-24 16:26:43
 * @LastEditors: zhao - 🍉
 * @Description: 划账记录
 * @FilePath: /zhzj-admin/src/page/TransferRecordLog/index.jsx
 */
class TransferRecordLog extends React.Component{
    constructor() {
        super()
        this.state = {
            merchantList: []
        }
    }
    componentDidMount() {
        this.postMerchantList()
    }

    handleEdit = (id) => {
        this.TransferRecordUpdateRef.open(id).then(() => {
            this.TableHelperRef.postDataSource()
        })
    }
    handleSettlementEdit =(id) =>{
        this.TransferRecordSettlementUpdateRef.open(id).then(() => {
            this.TableHelperRef.postDataSource()
        })
    }

    handleDetail = (id) => {
        this.TransferRecordDetailRef.open(id)
    }

    handleRecordDetails = (id) => {
        this.TransferRecordDetailInfoRef.open(id)
    }

    //对账记录详情
    handleAccountingRecordDetail = (id,loan) => {
        this.AccountingRecordDetailRef.open(id,loan)
    }



    handleOpenFlowApproval = (id) => {
        this.TransferRecordFlowApprovalModalRef.open(id).then(() => {
            this.TableHelperRef.postDataSource()
        })
    }
    handleOpenFlowList = (id) => {
        this.TransferRecordFlowListModalRef.open(id)
    }

    handleSftpUpload = (id) => {
        this.postSftpUpload({transferRecordLogId: id})
    }

    postMerchantList() {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                let merchantList = res.map((item) => ({
                    title: item.shortName,
                    value: item.id,
                    name: item.name,
                    isJr: item.isJr,
                    zjbDataSync: item.zjbDataSync,
                }));
                this.setState({ merchantList });
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
            });
    }

    postSftpUpload(data) {
        return fetchTransferRecordLogSftpUpload(data).then(() => {
            message.success('操作成功')
        })
    }

    render(){
        const mapFlowStatus = [
            { title: '通过', value: 1 },
            { title: '不通过', value: 2 },
            { title: '待审核', value: 3 },
        ]

        const mapTransferRecordStatus = [
            { title: '待审核', value: 1 },
            { title: '审核中', value: 2 },
            { title: '审核未通过', value: 3 },
            { title: '待支付', value: 4 },
            { title: '处理中', value: 5 },
            { title: '划付成功', value: 6 },
            { title: '划付失败', value: 7 },
            { title: '划分文件上传失败', value: 8 },
            { title: '部分分账成功', value: 9 },
        ]
        const mapTransferRecordType = [
            { title: '云贷费用', value: 1 },
            { title: '业主租金', value: 2 },
            { title: '平台运营费用', value: 3 },
            { title: '商户结余退款', value: 4 },
            { title: '其他费用', value: 5 },
            { title: '电子认证费用', value: 7 },
            { title: '物业运营服务费', value: 8 },
            { title: '代付业主租金', value: 9 },

        ]

        const mapNewsTransferRecordType = [
            { title: '代付平台云贷费用', value: 2 },
            { title: '平台服务费用', value: 3 },
            { title: '银联手续费', value: 4 },
            { title: '其他费用', value: 5 },
            { title: '电子认证费用', value: 7 },
            { title: '物业运营服务费', value: 8 },
            { title: '代付业主租金', value: 9 },

        ]

        const mapInstructionType = [
            { title: '银联分账', value: 1 },
            { title: '银联划付', value: 2 },
        ]

        const columns = [
            { title: '商户集团号', dataIndex: 'merchantGroupNumber' },
            { title: '商户简称', dataIndex: 'shortName' },
            { title: '银联指令类型', dataIndex: 'instructionType' , render: (text) => {
                    return findDict(mapInstructionType, text).title
                } },
            { title: '费用类型', dataIndex: 'transferRecordType', render: (text,records) => {
                    return records.recordDetailsId >0?
                     findDict(mapNewsTransferRecordType, text).title: findDict(mapTransferRecordType, text).title
                } },
            { title: '清算状态', dataIndex: 'transferRecordStatus', render: (text) => {
                    return findDict(mapTransferRecordStatus, text).title
                } },
            { title: '清算笔数', dataIndex: 'transferNum' },
            { title: '总金额', dataIndex: 'totalAmount' , render: (text) => {
                    return text ? moneyAddComma(text / 100) : text
                } },
            { title: '指令附件上传时间', dataIndex: 'uploadTime' , render: (text) => formatTime(text, 'YYYY-MM-DD HH:mm')},

            { title: '审批状态', dataIndex: 'flowStatus', render: (text) => {
                    return findDict(mapFlowStatus, text).title
                }  },
            { title: '流程接收人', dataIndex: 'flowReceiverByName' },
            { title: '流程审批时间', dataIndex: 'flowApprovalTime', render: (text) => formatTime(text, 'YYYY-MM-DD HH:mm') },
            { title: '流程备注', dataIndex: 'flowRemarks' },
            { title: '创建时间', dataIndex: 'createTime', render: (_, record) => {
                return formatTime(record.createTime || record.createTime, 'YYYY-MM-DD HH:mm:ss')
            }},
            {
                title: '操作', dataIndex: 'actions', width: 260, render: (_,records) => {
                    return (
                        <React.Fragment>
                            <AuthButton authkey="e-12-1" >
                                <a onClick={() => this.handleDetail(records.id)}>详情</a>
                                <Divider type="vertical" />
                            </AuthButton>
                            {records.accountingRecordLogId >0 && (
                            <AuthButton authkey="e-12-7" >
                                <a onClick={() => this.handleAccountingRecordDetail(records.accountingRecordLogId,records.loan)}>对账记录详情</a>
                                <Divider type="vertical" />
                            </AuthButton>)}
                            {records.recordDetailsId >0 && (
                                <AuthButton authkey="e-12-8" >
                                    <a onClick={() => this.handleRecordDetails(records.recordDetailsId)}>划账结算详情</a>
                                    <Divider type="vertical" />
                                </AuthButton>)}
                            {records.update && (
                                <AuthButton authkey="e-12-6" >
                                    <a onClick={() => this.handleEdit(records.id)}>修改</a>
                                    <Divider type="vertical" />
                                </AuthButton>
                            )}

                            {records.approve && (
                                <AuthButton authkey="e-12-2" >
                                    <a onClick={() => this.handleOpenFlowApproval(records.id)}>流程审批</a>
                                    <Divider type="vertical" />
                                </AuthButton>
                            )}
                            <AuthButton authkey="e-12-3" >
                                <a onClick={() => this.handleOpenFlowList(records.id)}>审批列表</a>
                            </AuthButton>
                            {
                                records.transferRecordStatus === 8 && (
                                    <React.Fragment>
                                        <Divider type="vertical" />
                                        <AuthButton authkey="e-12-4">
                                            <Popconfirm
                                                title="确认上传吗"
                                                onConfirm={() => {
                                                    this.handleSftpUpload(records.id);
                                                }}
                                            >
                                                <a >划账文件上传</a>
                                            </Popconfirm>
                                        </AuthButton>
                                    </React.Fragment>
                                )
                            }
                        </React.Fragment>
                    )
                }
            }
        ]
        const searchOptions = [
            { key: 'createTimeStart', type: 'date', placeholder: '请选择创建开始日期',width:150, },
            { key: 'createTimeEnd', type: 'date', placeholder: '请选择创建截止日期',width:150 },

            { key: 'transferRecordType', type: 'select', options: mapTransferRecordType ,initialValue: "1", placeholder: '费用类型', },
            { key: 'transferRecordStatus', type: 'select', options: mapTransferRecordStatus ,initialValue: "1", placeholder: '清算状态', },
            { key: 'instructionType', type: 'select', options: mapInstructionType ,initialValue: "1", placeholder: '指令类型', },
            { key: 'merchantId', type: 'select', placeholder: '商户', options: this.state.merchantList },
        ]
        return (
            <PageWrap>
                <TableHelper
                    ref={ref => this.TableHelperRef = ref}
                    columns={columns}
                    searchOptions={searchOptions}
                    request={fetchTransferRecordLogList}
                    scroll={{x:1400}}
                >
                    <div slot="search">
                        <AuthButton type="primary" icon="plus" authkey="e-12-6" onClick={() => this.handleSettlementEdit()}>
                            划账结算
                        </AuthButton>
                        &nbsp; &nbsp; &nbsp;
                       <AuthButton type="primary" icon="plus" authkey="e-12-6" onClick={() => this.handleEdit()}>
                            新增
                        </AuthButton>
                    </div>
                </TableHelper>
                <TransferRecordFlowApprovalModal ref={ref => this.TransferRecordFlowApprovalModalRef = ref } />
                <TransferRecordDetail getRef={ref => this.TransferRecordDetailRef = ref} />
                <TransferRecordDetailInfo getRef={ref => this.TransferRecordDetailInfoRef = ref} />
                <TransferRecordFlowListModal getRef={ref => this.TransferRecordFlowListModalRef = ref} />
                <TransferRecordUpdate getRef={ref => this.TransferRecordUpdateRef = ref} />
                <TransferRecordUpdate getRef={ref => this.TransferRecordUpdateRef = ref} />
                <AccountingRecordDetail ref={ref => { this.AccountingRecordDetailRef = ref }} />
                <TransferRecordSettlementUpdate  wrappedComponentRef={ref => { this.TransferRecordSettlementUpdateRef = ref }} />

            </PageWrap>

        )
    }
}

export default TransferRecordLog


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/index.jsx